import { render } from "./accueil.vue?vue&type=template&id=61c03386&scoped=true"
import script from "./accueil.vue?vue&type=script&lang=js"
export * from "./accueil.vue?vue&type=script&lang=js"

import "./accueil.vue?vue&type=style&index=0&id=61c03386&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c03386"]])

export default __exports__